module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product5-56793e5468fa029e83bc37167f006ae4.jpg";